import { FeatureToggleClientService } from 'feature-toggle-client';
const cdpVisibility = 'cdp-beta';
const betaAcess = 'cdp-allowed-contracts';
export class CDPFeatures {
    static async isCdpEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(cdpVisibility);
    }
    static async isTenantIdOnBeta(tenantId) {
        try {
            const allFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
            const allowedTenants = allFlags[betaAcess].tenants;
            return allowedTenants.includes(tenantId);
        }
        catch {
            return false;
        }
    }
}
